import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Profesionales de 35 a 50 años que sienten que el suelo se mueve bajo sus pies.', 'Empleados corporativos cansados de ser tratados como números en una hoja de Excel.', 'Freelancers y creativos cuyos precios están cayendo por la competencia de herramientas gratuitas.', 'Mandos medios que necesitan redefinir su liderazgo en equipos híbridos (humanos e IA).'];
  const notForWho = ['Personas que buscan un "hack" mágico para hacerse ricos con ChatGPT en dos días.', 'Quienes creen que la tecnología no cambiará nada en la próxima década.', 'Perfiles que prefieren la comodidad de recibir órdenes mecánicas sin cuestionar el propósito.'];
  const steps = [{
    num: '01',
    title: 'Diagnóstico',
    desc: 'Identificas en menos de 10 minutos qué tareas de tu día te están haciendo despedible.'
  }, {
    num: '02',
    title: 'Blindaje',
    desc: 'Aplicas las 4 capas de valor humano para inyectar criterio en cada entregable.'
  }, {
    num: '03',
    title: 'Posicionamiento',
    desc: 'Usas el plan de 21 días para que tu entorno deje de verte como un coste y empiece a verte como un activo indispensable.'
  }];
  return <section className="py-20 px-4 bg-dark-900 border-t border-gold-500/10" data-id="element-8">
      <div className="max-w-5xl mx-auto" data-id="element-9">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-24" data-id="element-10">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-dark-800/50 p-8 rounded-xl border border-green-900/30" data-id="element-11">
            <h3 className="text-2xl font-serif text-white mb-6 flex items-center" data-id="element-12">
              <CheckCircle2 className="w-6 h-6 text-green-500 mr-3" data-id="element-13" />
              Para quién es esto
            </h3>
            <ul className="space-y-4" data-id="element-14">
              {forWho.map((item, i) => <li key={i} className="flex items-start text-gray-300" data-id="element-15">
                  <span className="text-green-500 mr-2 mt-1" data-id="element-16">•</span>
                  {item}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-dark-800/50 p-8 rounded-xl border border-red-900/30" data-id="element-17">
            <h3 className="text-2xl font-serif text-white mb-6 flex items-center" data-id="element-18">
              <XCircle className="w-6 h-6 text-red-500 mr-3" data-id="element-19" />
              Para quién NO es
            </h3>
            <ul className="space-y-4" data-id="element-20">
              {notForWho.map((item, i) => <li key={i} className="flex items-start text-gray-400" data-id="element-21">
                  <span className="text-red-500 mr-2 mt-1" data-id="element-22">•</span>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-serif text-gold-500 mb-12 text-center" data-id="element-24">
            Cómo funciona
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-25">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative bg-dark-800 p-8 rounded-lg border border-gold-500/10" data-id="element-26">
                <div className="text-5xl font-serif text-gold-500/20 absolute top-4 right-4" data-id="element-27">
                  {step.num}
                </div>
                <h4 className="text-xl font-serif text-white mb-4 relative z-10" data-id="element-28">
                  {step.title}
                </h4>
                <p className="text-gray-400 relative z-10" data-id="element-29">{step.desc}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}